export default {
  install(Vue, options) {
    Vue.prototype.checkMobile = (val) => {
      // let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      let reg = /^1[0-9]{10}$/;
      if (reg.test(val)) {
        return true
      } else {
        return false
      }
    };
    Vue.prototype.checkFixedPhone = (val) => {
      let reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
      let resa = /^400 \- [0-9]{0,7} \- [0-9]{1,7}$/;
      if( reg.test(val) || resa.test(val) ){
        return true
      } else {
        return false
      }
    };
    Vue.prototype.checkEmail = (val) => {
      // let email = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      let email = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g
      if (email.test(val)) {
        return true
      } else {
        return false
      }
    };
    Vue.prototype.onlyNum = (val, len=99) => {
      val = val + '';
      if(val.length==1){
        val = val.replace(/[^1-9]/g,'')
      } else if(val.length>=len){
        val = val.substring(0, len)
      } else {
        val = val.replace(/\D/g,'')
      }
      if( isNaN(val) ){ return '' } // 防止复制粘贴非数字，出现NaN
      return val
    };
    Vue.prototype.IdentityCodeValid = (code) => {
      var city = { 11:"北京", 12:"天津", 13:"河北", 14:"山西", 15:"内蒙古", 21:"辽宁", 22:"吉林", 23:"黑龙江", 31:"上海", 32:"江苏", 33:"浙江", 34:"安徽", 35:"福建", 36:"江西", 37:"山东", 41:"河南", 42:"湖北", 43:"湖南", 44:"广东", 45:"广西", 46:"海南", 50:"重庆", 51:"四川", 52:"贵州", 53:"云南", 54:"西藏", 61:"陕西", 62:"甘肃", 63:"青海", 64:"宁夏", 65:"新疆", 71:"台湾", 81:"香港", 82:"澳门", 91:"国外" };
      var tip = "";
      var pass = true;
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      if (!code) {
        tip = "身份证号不能为空";
        pass = false;
      } else if (!regIdCard.test(code)) {
        tip = "请输入正确的身份证号码";
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        // tip = "地址编码错误";
        tip = "请输入正确的身份证号码";
        pass = false;
      } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.toUpperCase();
          code = code.split('');
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
          var sum = 0;
          var ai = 0;
          var wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          var last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            // tip = "校验位错误";
            tip = "请输入正确的身份证号码";
            pass = false;
          }
        }
      }
      return {
        'tips': tip,
        'type': pass
      };
    };
    Vue.prototype.specificTime = (format, timestamp) => {
      /**
       specificTime('Y-m-d','1350052653');       // => 2012-10-11
       specificTime('Y-m-d H:i:s','1350052653'); // => 2012-10-12 22:37:33
       */
      var a, jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date());
      var pad = function(n, c) {
        if ((n = n + "").length < c) {
          return new Array(++c - n.length).join("0") + n;
        } else {
          return n;
        }
      };
      var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      var txt_ordin = { 1: "st", 2: "nd", 3: "rd", 21: "st", 22: "nd", 23: "rd", 31: "st" };
      var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var f = {
        // Day
        d: function() {
          return pad(f.j(), 2)
        },
        D: function() {
          return f.l().substr(0, 3)
        },
        j: function() {
          return jsdate.getDate()
        },
        l: function() {
          return txt_weekdays[f.w()]
        },
        N: function() {
          return f.w() + 1
        },
        S: function() {
          return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
        },
        w: function() {
          return jsdate.getDay()
        },
        z: function() {
          return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0
        },
        // Week
        W: function() {
          var a = f.z(),
            b = 364 + f.L() - a;
          var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
          if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
            return 1;
          } else {
            if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
              nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
              return date("W", Math.round(nd2.getTime() / 1000));
            } else {
              return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
            }
          }
        },
        // Month
        F: function() {
          return txt_months[f.n()]
        },
        m: function() {
          return pad(f.n(), 2)
        },
        M: function() {
          return f.F().substr(0, 3)
        },
        n: function() {
          return jsdate.getMonth() + 1
        },
        t: function() {
          var n;
          if ((n = jsdate.getMonth() + 1) == 2) {
            return 28 + f.L();
          } else {
            if (n & 1 && n < 8 || !(n & 1) && n > 7) {
              return 31;
            } else {
              return 30;
            }
          }
        },
        // Year
        L: function() {
          var y = f.Y();
          return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
        },
        //o not supported yet
        Y: function() {
          return jsdate.getFullYear()
        },
        y: function() {
          return (jsdate.getFullYear() + "").slice(2)
        },
        // Time
        a: function() {
          return jsdate.getHours() > 11 ? "pm" : "am"
        },
        A: function() {
          return f.a().toUpperCase()
        },
        B: function() {
          // peter paul koch:
          var off = (jsdate.getTimezoneOffset() + 60) * 60;
          var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
          var beat = Math.floor(theSeconds / 86.4);
          if (beat > 1000) beat -= 1000;
          if (beat < 0) beat += 1000;
          if ((String(beat)).length == 1) beat = "00" + beat;
          if ((String(beat)).length == 2) beat = "0" + beat;
          return beat;
        },
        g: function() {
          return jsdate.getHours() % 12 || 12
        },
        G: function() {
          return jsdate.getHours()
        },
        h: function() {
          return pad(f.g(), 2)
        },
        H: function() {
          return pad(jsdate.getHours(), 2)
        },
        i: function() {
          return pad(jsdate.getMinutes(), 2)
        },
        s: function() {
          return pad(jsdate.getSeconds(), 2)
        },
        O: function() {
          var t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4);
          if (jsdate.getTimezoneOffset() > 0) t = "-" + t;
          else t = "+" + t;
          return t;
        },
        P: function() {
          var O = f.O();
          return (O.substr(0, 3) + ":" + O.substr(3, 2))
        },
        c: function() {
          return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()
        },
        U: function() {
          return Math.round(jsdate.getTime() / 1000)
        }
      };
      return format.replace(/([\]?([a-zA-Z])/g, function(t, s) {
        var ret;
        if (t != s) { // escaped
          ret = s;
        } else if (f[s]) { // a date function exists
          ret = f[s]();
        } else { // nothing special
          ret = s;
        }
        return ret;
      })
    };
    Vue.prototype.confirm = {
      email: /^([0-9A-Z_]+)@([0-9A-Z]{2,})\.([A-Z]{2,})$/i,
      phone: /^1[0-9]{10}$/,
      psw: /^[0-9a-zA-Z]{6,16}$/
    }
  }
};